import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Image } from 'antd';
import { Nav } from '../../components/Nav/index';
import { CopyOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useScroll } from 'ahooks';
import exchange from '../../assets/exchange.png';
import block1 from './assets/block1.png';
import block2 from './assets/block2.png';
import block3 from './assets/block3.png';
import block4 from './assets/block4.png';
import block5 from './assets/block5.png';
import block6 from './assets/block6.png';

const ExchangeCode = () => {
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code') || '';
    const scroll = useScroll(document);

    const handleCopy = () => {
        navigator.clipboard.writeText(code).then(() => {
            message.success('复制成功');
        });
    };

    return (
        <div className="flex min-h-screen flex-col bg-white">
            <Nav hasBottomBorder={true} bgWhite={true} />

            {/* Tab栏 */}
            <div className="mb-16 mt-6 flex justify-center">
                <div className="flex h-[38px] cursor-pointer items-center justify-center rounded-[19px] bg-primary px-4 text-white">
                    答辩PPT兑换码
                </div>
            </div>

            <div className="mx-auto h-[164px] w-[216px] object-contain">
                <img
                    src={exchange}
                    alt="兑换码"
                    className="mx-auto h-[164px] w-[216px] object-contain"
                />
            </div>

            {/* 兑换码展示和复制 */}
            <div className="mb-10 flex flex-col items-center">
                <div className="flex h-[48px] w-max items-center justify-center rounded-[24px] bg-primary px-6 text-white">
                    <span className="mr-2">{code}</span>
                </div>
                <div className="mt-2 cursor-pointer hover:text-primary" onClick={handleCopy}>
                    复制兑换码
                </div>
            </div>

            {/* 使用说明 */}
            <div className="mx-auto w-[60vw] rounded-[16px] bg-[#F9FBFF] p-6 text-left">
                <h3 className="mb-4 text-lg font-medium text-[#1D2129]">兑换码使用方法~</h3>
                {/* 每行3个图片 */}
                <div className="grid grid-cols-3 gap-3">
                    <Image src={block1} alt="block1" />
                    <Image src={block2} alt="block2" />
                    <Image src={block3} alt="block3" />
                    <Image src={block4} alt="block4" />
                    <Image src={block5} alt="block5" />
                    <Image src={block6} alt="block6" />
                </div>
            </div>
        </div>
    );
};

export default ExchangeCode;
